import { LayoutItem } from "node_modules/react-grid-layout/dist";
import { DashboardWidgetDefinition } from "src/types/dashboard";

const buildLayoutItem = ({
  i,
  x,
  y,
  w,
  h,
  minW,
  minH,
  maxW,
  maxH,
  static: isStatic = false,
  isDraggable,
  isResizable,
  resizeHandles,
  isBounded = false,
  moved = false,
  constraints,
}: LayoutItem): LayoutItem => ({
  i,
  x,
  y,
  w,
  h,
  minW,
  minH,
  maxW,
  maxH,
  static: isStatic,
  isDraggable: isDraggable ?? !isStatic,
  isResizable: isResizable ?? !isStatic,
  resizeHandles,
  isBounded,
  moved,
  constraints,
});

export const toLayoutItem = (widget: DashboardWidgetDefinition): LayoutItem =>
  buildLayoutItem({
    i: String(widget.id),
    x: widget.grid.x,
    y: widget.grid.y,
    w: widget.grid.w,
    h: widget.grid.h,
    minW: widget.grid_constraints.min_w,
    minH: widget.grid_constraints.min_h,
    maxW: widget.grid_constraints.max_w,
    maxH: widget.grid_constraints.max_h,
    static: false,
    isDraggable: false,
    isResizable: false,
  });

export function formatNumber(num: number) {
  if (num === null || num === undefined) return "";
  if (typeof num === "string") return num;

  return num.toLocaleString("en-US");
}

export const toSnakeCase = (str: string) => {
  return str
    ?.match(
      /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g,
    )
    ?.map((x) => x.toLowerCase())
    ?.join("_");
};
